import { useQuery } from '@tanstack/react-query';

import {
  getBankAccountStatuses,
  getBankAccountStatusesKey,
} from '../services/bankAccountStatus.service';

const useQueryBankAccountStatusesHook = (orgId: string, brandId: string, isEnabled = true) => {
  const { data, isPending, isFetching } = useQuery({
    queryKey: [getBankAccountStatusesKey, orgId, brandId],
    queryFn: () => getBankAccountStatuses(orgId, brandId),
    enabled: isEnabled && !!orgId && !!brandId,
  });

  const statuses = data?.data ?? [];

  const hasFailedPayout = statuses.some((account) => account.lastPayoutFailed);

  // Matches a bank account's Stripe id (StripeConnectedAccountInfo.StripeId) against the
  // status API's accountId to determine whether that specific account's last payout failed.
  const hasFailedPayoutForStripeId = (stripeId?: string) =>
    !!stripeId &&
    statuses.some((status) => status.accountId === stripeId && status.lastPayoutFailed);

  return {
    statuses,
    hasFailedPayout,
    hasFailedPayoutForStripeId,
    isPending,
    isFetching,
  };
};

export default useQueryBankAccountStatusesHook;
